
export class CriteriaHideShowProperties {
  tripTypeToggle: boolean = false;
  searchFields: boolean = false;
  dateChangeFields: boolean = false;
  passengerAdd: boolean = false;
  filtersModifySearch: boolean = false;
  
}
